import { ApogeuLogo } from "./ApogeuLogo";

export function LoadingScreen({ label = "Carregando seu CT..." }: { label?: string }) {
  return (
    <div className="auth-screen auth-screen--dark">
      <div className="brand-tile brand-tile--large">
        <ApogeuLogo width={54} />
      </div>
      <div className="loading-dots" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
      <p className="auth-screen__muted">{label}</p>
    </div>
  );
}
